import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useFlags } from '@saucelabs/sl-util-launchdarkly';
import { Button } from '@saucelabs/ds-button';
import { Link } from 'react-router-dom';

import { BILLING_INTERVALS } from '../../constants';
import { Actions, Heading, List } from './PopoverComponents';

const OneClickBillingPopover = ({
  checkoutCopy,
  showCheckoutButton,
  isAutomated,
  isMobile,
  onCheckout,
  onClose,
  onEditOrder,
  isFreemiumCapableOnUsage,
}) => {
  const flags = useFlags();
  const showAnnualPrices = flags?.growthOneClickBillingAnnualPrices &&
    !isFreemiumCapableOnUsage;

  let checklist;
  if (isFreemiumCapableOnUsage) {
    checklist = [
      'Use credits to run Live and Automated testing.',
      'Access thousands of Real and Virtual Devices.',
    ];
  } else if (isAutomated) {
    checklist = [
      'Unlimited automated and live testing minutes',
      'Unlimited users',
      'Unlimited use of desktop browsers & virtual devices',
    ];
  } else {
    checklist = [
      'Unlimited live testing minutes',
      'Unlimited users',
      'Unlimited use of desktop browsers, real & virtual devices',
    ];
  }

  return (
    <div
      className={classNames('w-50 max-w-screen bg-white border border-gray-200 border-solid shadow-md rounded p-3 absolute right-0 top-full mt-0.5', {
        'w-full': isMobile,
      })}
      style={{
        width: 528,
      }}
    >
      <Heading onClose={onClose}>
        {isFreemiumCapableOnUsage ? 'Buy credits to do more testing.' : (
          <>
            Upgrade to a
            {' '}
            {showAnnualPrices ?
              BILLING_INTERVALS.YEAR :
              BILLING_INTERVALS.MONTH}
            {' '}
            of unlimited testing.
          </>
        )}
      </Heading>
      <List checkList={checklist} />
      <Actions>
        {isFreemiumCapableOnUsage ? (
          <>
            <Button
              block
              className="text-center w-full"
              onPress={onCheckout}
            >
              <span>{checkoutCopy}</span>
            </Button>
            <Button
              block
              className="text-center mt-2"
              component={Link}
              to="/billing/purchase#how-credits-work"
              variant="text"
            >
              Read credit FAQs
            </Button>
          </>
        ) : (
          <>
            <Button
              category="action"
              className="justify-center"
              data-qa="one-click-billing-checkout"
              onPress={onCheckout}
            >
              <span>{checkoutCopy}</span>
            </Button>
            {showCheckoutButton && (
              <Button
                category="action-inv"
                className="justify-center"
                data-qa="one-click-billing-edit-detail"
                onPress={onEditOrder}
                variant="outline"
              >
                {'View all plans'}
              </Button>
            )}
          </>
        )}
      </Actions>
    </div>
  );
};

OneClickBillingPopover.propTypes = {
  checkoutCopy: PropTypes.node,
  isAutomated: PropTypes.bool,
  isFreemiumCapableOnUsage: PropTypes.bool,
  isMobile: PropTypes.bool,
  onCheckout: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onEditOrder: PropTypes.func.isRequired,
  showCheckoutButton: PropTypes.bool,
};

OneClickBillingPopover.defaultProps = {
  checkoutCopy: '1 Click Checkout',
  isAutomated: false,
  isFreemiumCapableOnUsage: false,
  isMobile: false,
  onClose: () => {},
  showCheckoutButton: true,
};

export default OneClickBillingPopover;
